<template>
    <div id="RaiseNewCaseItem">
        <a-row>
            <a-col :span="24" class="titleArea">
                {{title}}
            </a-col>
        </a-row>
        <a-row v-for="(item, index) in inputConfig" :key="index">
            <NormalInput :isCanEdit="isCanEdit" :ref="newRef(index)" :data="item" :index="index"></NormalInput>
        </a-row>
    </div>
</template>

<script>
import NormalInput from './NormalInput'

export default {
  name: 'RaiseNewCaseItem',
  props: ['inputConfig', 'title', 'isCanEdit'],
  components: {
    NormalInput
  },
  data () {
    return {
      isok: true
    }
  },
  destroyed () {
  },
  created () {
  },
  methods: {
    newRef (index) {
      return 'child' + index
    },
    showAllInputMsg () {

    },
    checkText () {
      // for (var i=0;i<this.inputConfig.length;i++) {
      //   const childS = newRef(i)
      //   this.$refs.childS.checkValue(this.inputConfig[i])
      // }
      // console.log(22222)
    },
    valueChanged (data) {
      var item = this.inputConfig[data.index]
      item.isOk = data.isOk
      this.inputConfig[data.index] = item
      // console.log('valueChanged : ', data)
      // console.log('this.inputConfig : ', this.inputConfig)

      this.$emit('dataValueChange', this.inputConfig)
    }
  }
}
</script>

<style lang="scss" scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #RaiseNewCaseItem {
         .titleArea {
             padding: 5px;
             border-bottom: 1px solid #91d5ff;
             color: #027DB4;
             font-weight: 800;
             font-size: 16px;
         }
     }

</style>
